export default "__VITE_ASSET__CSNQ6Liv__"